import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch, Route, withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import { setPageTitle, setPageSubTitle } from "../../store/preferences/actions";
import PeopleTable from "../../components/People/PeopleTable";
import { fetchPerson, fetchPeople } from "../../store/people/actions";
import { fetchGroupPeople } from "../../store/groups/actions";
import { PeoplePage } from "../index";
import queryString from "querystring";

class Group extends Component {
  componentDidMount = () => {
    const {
      match,
      fetchGroupPeople,
      userId,
      intl,
      siteLanguage,
      setPageTitle,
      numberOfGroupPeople,
      setPageSubTitle,
      groupName,
      groupPeopleLimit,
      groupPeoplePage,
    } = this.props;
    const qs = queryString.parse(window.location.search);
    fetchGroupPeople(
      match.params.groupId,
      userId,
      intl,
      siteLanguage,
      groupPeopleLimit,
      groupPeoplePage,
      qs["?q"]
    );
    setPageTitle(groupName);
    setPageSubTitle(
      `${numberOfGroupPeople} ${
        numberOfGroupPeople === 1
          ? "Person is in this group"
          : "People are in this group"
      }`
    );
  };
  componentWillReceiveProps(newProps) {
    const {
      match,
      fetchGroupPeople,
      userId,
      intl,
      siteLanguage,
      setPageTitle,
      groupPeopleLimit,
      groupPeoplePage,
      location,
    } = this.props;
    const qs = queryString.parse(location.search);
    const newpropsqs = queryString.parse(newProps.location.search);

    if (
      newProps.match.params.groupId !== match.params.groupId ||
      qs["?q"] !== newpropsqs["?q"]
    ) {
      fetchGroupPeople(
        newProps.match.params.groupId,
        userId,
        intl,
        siteLanguage,
        groupPeopleLimit,
        groupPeoplePage,
        newpropsqs["?q"]
      );
    }
    setPageTitle(
      `${newProps.numberOfGroupPeople} ${
        newProps.numberOfGroupPeople === 1 ? "Person" : "People"
      }`
    );
  }

  render() {
    const {
      groupPeople,
      fetchingGroupPeople,
      groups,
      screen,
      fetchingPerson,
      person,
      userId,
      intl,
      siteLanguage,
      location,
      fetchPeople,
      fetchedGroupPeople,
      uploadingPeopleFromFile,
      numberOfGroupPeople,
      totalNumberOfGroupPeople,
      groupPeopleLimit,
      query,
      groupPeoplePage,
    } = this.props;
    let peopleData = groupPeople.map((person, index) => {
      const { Custom, ...rest } = person.data;
      return {
        key: person.uuid,
        ...rest,
        Name:
          (person.data["First Name"] || person.data["First Name "] || "") +
          " " +
          (person.data["Last Name"] || person.data["Last Name "] || ""),
        "GPS Location":
          (person.data["GPS Location"] && person.data["GPS Location"].latitude
            ? person.data["GPS Location"].latitude + ","
            : "") +
          +(person.data["GPS Location"] && person.data["GPS Location"].longitude
            ? person.data["GPS Location"].longitude
            : ""),
        posted_ts: person["posted_ts"],
      };
    });
    return (
      <React.Fragment>
        <PeopleTable
          query={query}
          groups={groups}
          tableFor="group"
          people={peopleData}
          loading={fetchingGroupPeople}
          screen={screen}
          fetchingPerson={fetchingPerson}
          person={person}
          userId={userId}
          intl={intl}
          siteLanguage={siteLanguage}
          totalNumberOfPeople={totalNumberOfGroupPeople}
          numberOfPeople={numberOfGroupPeople}
          peoplePage={groupPeoplePage}
          peopleLimit={groupPeopleLimit}
          fetchPeople={fetchPeople}
          fetchedPeople={fetchedGroupPeople}
          fetchingPeople={fetchingGroupPeople}
          uploadingPeopleFromFile={uploadingPeopleFromFile}
          location={location}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  siteLanguage: state.intl.siteLanguage,
  userId: state.user.userId,
  groupPeople: state.groups.groupPeople,
  groups: state.groups.groups,
  query: state.groups.query,
  fetchingPerson: state.people.fetchingPerson,
  person: state.people.person,
  numberOfGroupPeople: state.groups.numberOfGroupPeople,
  totalNumberOfGroupPeople: state.groups.totalNumberOfGroupPeople,
  groupPeopleLimit: state.groups.groupPeopleLimit,
  groupPeoplePage: state.groups.groupPeoplePage,
  fetchingGroupPeople: state.groups.fetchingGroupPeople,
  groupName: state.groups.groupName,
  parentGroupId: state.groups.parentGroupId,
  groupType: state.groups.groupType,
  fetchedGroupPeople: state.groups.fetchedGroupPeople,
  uploadingPeopleFromFile: state.people.uploadingPeopleFromFile,
});

const mapDispatchToProps = (dispatch) => ({
  fetchGroupPeople: (
    groupsId,
    userId,
    intl,
    siteLanguage,
    limit,
    page,
    query
  ) => {
    dispatch(
      fetchGroupPeople(groupsId, userId, intl, siteLanguage, limit, page, query)
    );
  },
  setPageTitle: (title) => {
    dispatch(setPageTitle(title));
  },
  fetchPerson: (personId, userId, intl, siteLanguage) => {
    dispatch(fetchPerson(personId, userId, intl, siteLanguage));
  },

  fetchPeople: (userId, limit, page, intl, siteLanguage) => {
    dispatch(fetchPeople(userId, limit, page, intl, siteLanguage));
  },
  setPageSubTitle: (subtitle) => {
    dispatch(setPageSubTitle(subtitle));
  },
});
export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(Group))
);
